import { BankFilled, BellFilled, CalendarFilled, CalendarOutlined, CheckCircleOutlined, CheckOutlined, CheckSquareOutlined, ClockCircleFilled, ClockCircleOutlined, DownloadOutlined, EditOutlined, EnvironmentFilled, EnvironmentOutlined, EyeOutlined, FileImageOutlined, GlobalOutlined, GoogleOutlined, MenuOutlined, NotificationFilled, PhoneFilled, PhoneOutlined, QuestionCircleFilled, QuestionCircleOutlined, RightOutlined, SafetyCertificateFilled, SafetyCertificateOutlined, SearchOutlined, SecurityScanOutlined, ShopOutlined, StopOutlined, SwapOutlined, TagOutlined, UploadOutlined, WarningFilled } from '@ant-design/icons';
import { Badge, Button, Card, Col, Input, Progress, Row, Segmented, Switch, Tag, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import Checkbox from 'antd/lib/checkbox/Checkbox';
import { useContext, useMemo, useState } from 'react';
import { useFetch } from '../../../../hooks/useFetch/useFetch';
import { useAuth } from '../../../../store/AuthContext/AuthContext';
import { Categories, ContactGroup, Festives, Hours, Location, LocationCardCompacted } from '../../../components/model/business/FieldsGroup';
import {GoogleEditPanel} from './GoogleEditPanel';
import './GoogleLocations.css';
import TableLZM from '../../../components/design/table/TableLZM';
import { FilterDropdownProps } from 'antd/lib/table/interface';
import { DrawerContext } from '../../../../store/DrawerContext/DrawerContext';
import { GlobalVariableContext } from '../../../../store/GlobalVariableContext/GlobalVariableContext';
import { Synchronized } from '../../../components/design/Synchronized/Synchronized';
import { SCHEDULEDJOB } from '../../../../common/constants/services';
import { AlertsView } from '../../common/reports/AlertsView';
import { BlockInfoKpis } from '../../menuReports/blocks/BlockInfoKpis';
import { useIsAuthorized } from '../../common/roles/Roles';
import { ButtonLZ } from '../../../components/design/Buttons/ButtonLZ';
import SelectVirtualGroup, { NO_REGION_FILTER } from '../../../components/model/selectMonths/SelectVirtualGroup';
import LogoMassivePanel from './LogoMassivePanel';
import PortadaMassivePanel from './PortadaMassivePanel';
import {
	VERIFY_STATUS,
	GOOGLE_FIELD_SEVERITY_COLOR,
	GOOGLE_FIELD_SEVERITY_SOFT,
	GoogleUpdateModal,
	getGoogleAlertFlags,
	getGoogleAlertSeverity,
	getGoogleFieldSeverity,
	getGoogleFieldTagStyle,
	getNonOperableLabel,
	matchesGoogleFieldFilter,
	visibleGoogleFields,
} from './GoogleUpdateModal';
import { has } from 'lodash';
import { PageTitle } from '../../common/PageTitle';
import { PageFilters, PageFilterField } from '../../common/PageFilters';

export const GoogleLocations = () => {

	const { t } = useTranslation();
	const { projectGroup } = useAuth();
	
	const isAuthorized = useIsAuthorized();
	const { setLocationDrawer, setLogsDrawer } = useContext(DrawerContext)
	const { updateGlobalData } = useContext(GlobalVariableContext)	

	const [editPanelVisible, setEditPanelVisible] = useState(false);
	const [logoPanelVisible, setLogoPanelVisible] = useState(false);
	const [portadaPanel, setPortadaPanel] = useState(false);	
	const [updateData, setUpdateData] = useState(false);
	const [selectedRowKeys, setSelectedRowKeys] = useState<any>([]);
	const [indeterminate, setIndeterminate] = useState(false);
	const [locationsData, setLocationsData] = useState([]);

	const [isLoading, setIsLoading] = useState(true);
	const [filterStatus, setFilterStatus] = useState(true);
	const [filterLabel, setFilterLabel] = useState(null);
	const [openStatusFilter, setOpenStatusFilter] = useState<'open' | 'closed' | null>(null);
	const [kpis, setKpis] = useState<any>();	
	const [googleUpdatedModal, setGoogleUpdatedModal] = useState(null);

	const displayedLocations = useMemo(() => {
		let data = locationsData;
		if (filterLabel === NO_REGION_FILTER) {
			data = data.filter((row: any) => !row.location?.label);
		}
		if (openStatusFilter) {
			data = data.filter((row: any) => {
				const isClosed = row.location?.openForBusiness?.status?.includes('CLOSED');
				return openStatusFilter === 'closed' ? isClosed : !isClosed;
			});
		}
		return data;
	}, [locationsData, openStatusFilter, filterLabel]);

	const isUserAuthorized = isAuthorized(['ROLE_ADMIN', 'ROLE_AGENT', 'ROLE_CLIENT', 'ROLE_MODULE_INFO']);

	const apiFilterLabel = filterLabel === NO_REGION_FILTER ? '' : (filterLabel || '');

	useFetch(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/${projectGroup.group}/locations?hasVoiceOfMerchant=${filterStatus}&filterLabel=${encodeURIComponent(apiFilterLabel)}`,
		{},
		[updateData, updateGlobalData, filterLabel],
		(data) => {
			
			//debugger;
			setIsLoading(false);
			setLocationsData(data.locations);			
			//setSyncStatesPercentatge(data.syncStatesPercentatge);
			setKpis(data.kpis);			
		}
	);

	const START_COLUMNS: any = [		
		{
			title: 'Establecimiento',
			key: 'location',			
			width: '350px',
			//sorter: (a: any, b: any) => a.location.locality?.localeCompare(b.location.locality),
			filterDropdown: ({
			  setSelectedKeys,
			  selectedKeys,
			  confirm,			  
			}: FilterDropdownProps) => {
			  return (
				<Input
				  autoFocus
				  //placeholder="Filtro"
				  value={selectedKeys[0]}
				  onChange={(e: any) => {
					setSelectedKeys(e.target.value ? [e.target.value] : []);
					confirm({ closeDropdown: false });
				  }}
				  onPressEnter={() => {
					confirm();
				  }}
				  onBlur={() => {
					confirm();
				  }}
				></Input>
			  );
			},
			filterIcon: () => {
			  return <SearchOutlined />;
			},
			onFilter: (value: any, record: any) => {
			  return record.location.title?.toLowerCase().includes(value?.toLowerCase()) 
			  || record.location?.administrativeArea?.toLowerCase().includes(value?.toLowerCase())
			  || record.location?.locality?.toLowerCase().includes(value?.toLowerCase());
			},
			render: (text: string, record: any) => (
				<LocationCardCompacted location={record.location} color='white' label={true}/>
			)			
		}
	]

	const END_COLUMNS: any = [									
		{
			title: 'Info',
			key: 'info',
			sorter: (a: any, b: any) => a.completedRatio.ratio - b.completedRatio.ratio,
			render: (text: string, record: any) => {				
				return 	<div style={{display:'flex', flexDirection:'column', alignItems:'center'}}>
							<Tooltip title={record.completedRatio.alerts.length > 0 && 	
							<><b>Campos por completar:</b>
								<AlertsView alerts={record.completedRatio.alerts}/></>			}>
								<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', minWidth: 90 }}>
									<div style={{ display: 'flex', alignItems: 'center', gap: 8, width: '100%' }}>
										<Progress
											type="line"
											percent={Math.round(record.completedRatio.ratio * 100)}
											strokeColor="#4A90E2"
											trailColor="#ffffff"
											style={{ width: 65, minWidth: 60, marginBottom: 0 }}
											showInfo={false}
										/>
										<span style={{
											fontSize: 13,
											color: "#6d819c",
											fontWeight: 500
										}}>
											{Math.round(record.completedRatio.ratio * 100)}%
										</span>
									</div>									
								</div>										
							</Tooltip>		
						</div>
			}
		},	
		{
			title: 'Estado de Google',
			key: 'alerts',
			filters: Object.entries(VERIFY_STATUS)
				.sort(([a], [b]) => {
					const rank = { critical: 0, warning: 1, low: 2 } as const;
					const severityDiff = rank[getGoogleFieldSeverity(a)] - rank[getGoogleFieldSeverity(b)];
					if (severityDiff !== 0) return severityDiff;
					return (VERIFY_STATUS[a] || a).localeCompare(VERIFY_STATUS[b] || b, 'es');
				})
				.map(([value, text]) => ({
					value,
					text: (
						<span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
							<span style={{
								width: 8,
								height: 8,
								borderRadius: '50%',
								background: GOOGLE_FIELD_SEVERITY_COLOR[getGoogleFieldSeverity(value)],
								flexShrink: 0,
							}} />
							{text}
						</span>
					),
				})),
			onFilter: (value: any, record: any) => matchesGoogleFieldFilter(record, value),
			render: (text: string, record: any) => {
				const googleStatus = record.googleStatus || record.location?.googleStatus;
				const { isNotOperative, hasPendingEdits, hasGoogleUpdated } = getGoogleAlertFlags(record);
				const pendingFields = visibleGoogleFields(googleStatus?.pendingFields);
				const updatedFields = visibleGoogleFields(googleStatus?.updatedFields);
				const pendingCount = pendingFields.length;
				const updatedCount = updatedFields.length;
				const hasWarnings = isNotOperative || hasPendingEdits || hasGoogleUpdated;

				const renderFieldTags = (fields: string[]) =>
					fields.map((fieldKey) => (
						<Tag
							key={fieldKey}
							style={getGoogleFieldTagStyle(fieldKey)}
						>
							{VERIFY_STATUS[fieldKey] || fieldKey}
						</Tag>
					));

				const severity = getGoogleAlertSeverity(record);

				const severityStyle = {
					critical: {
						text: '#dc2626',
						hoverBackground: GOOGLE_FIELD_SEVERITY_SOFT.critical.background,
					},
					warning: {
						text: '#FF7518',
						hoverBackground: GOOGLE_FIELD_SEVERITY_SOFT.warning.background,
					},
					low: {
						text: '#64748b',
						hoverBackground: GOOGLE_FIELD_SEVERITY_SOFT.low.background,
					},
					ok: {
						text: '#64748b',
						hoverBackground: '#f1f5f9',
					},
				}[severity];

				return (
					<button
						type="button"
						onClick={() => setGoogleUpdatedModal(record)}
						style={{
							display: 'flex',
							alignItems: 'center',
							gap: 10,
							cursor: 'pointer',
							width: 300,
							padding: '6px 10px',
							margin: 0,
							border: '1px solid #eee',
							borderRadius: 8,
							background: '#fcfcfc',
							boxShadow: 'none',
							textAlign: 'left',
							transition: 'border-color 0.15s, background 0.15s',
						}}
						onMouseEnter={(e) => {
							e.currentTarget.style.background = severityStyle.hoverBackground;
							e.currentTarget.style.borderColor = severityStyle.text;
						}}
						onMouseLeave={(e) => {
							e.currentTarget.style.background = '#fcfcfc';
							e.currentTarget.style.borderColor = '#eee';
						}}
					>
						<GoogleOutlined style={{ fontSize: 24, color: severityStyle.text, flexShrink: 0 }} />
						<div style={{ display: 'flex', flexDirection: 'column', gap: 6, flex: 1, minWidth: 0 }}>
							{isNotOperative && (
								<span style={{ fontSize: 12, fontWeight: 500, color: severityStyle.text }}>
									{getNonOperableLabel(googleStatus?.gainVoiceOfMerchantAction)}
								</span>
							)}
							{hasPendingEdits && (
								<div style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
									<span style={{ fontSize: 12, fontWeight: 500, color: severityStyle.text }}>
										{pendingCount > 0
											? (pendingCount === 1
												? '1 alerta de cambios pendientes'
												: `${pendingCount} alertas de cambios pendientes`)
											: 'Alertas de cambios pendientes'}
									</span>
									{pendingFields.length > 0 && (
										<div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
											{renderFieldTags(pendingFields)}
										</div>
									)}
								</div>
							)}
							{hasGoogleUpdated && (
								<div style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
									<span style={{ fontSize: 12, fontWeight: 500, color: severityStyle.text }}>
										{updatedCount > 0
											? (updatedCount === 1
												? '1 alerta de cambios de Google'
												: `${updatedCount} alertas de cambios de Google`)
											: 'Alertas de cambios de Google'}
									</span>
									{updatedFields.length > 0 && (
										<div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
											{renderFieldTags(updatedFields)}
										</div>
									)}
								</div>
							)}
							{!hasWarnings && (
								<span style={{ fontSize: 12, fontWeight: 500, color: severityStyle.text }}>
									Sin Alertas de Google
								</span>
							)}
						</div>
						<RightOutlined style={{ fontSize: 11, color: severityStyle.text, flexShrink: 0 }} />
					</button>
				);
			}
		},	
		{
			title: '',
			key: 'actions',			
			render: (text: string, record: any) => (
				<div style={{display:'flex', justifyContent:'space-around'}}>																														
					<ButtonLZ type='primary' onClick={() => {setLocationDrawer(record.location.composeId);}} size='small'>    
						<ShopOutlined style={{ color: 'white' }}/> Editar
					</ButtonLZ>						
				</div>
			)
		}
	]
	
	/*count={false && <SafetyCertificateFilled style={{ color: 'MediumVioletRed', fontSize:'17px' }}/>}*/
	
	const [extraColumn, setExtraColumn] = useState('CATEGORY');

	const getDynamicTitle = (columnKey: string): any => {		
		return (
			<div style={{ display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'flex-start' }}>
				<div style={{ display: 'flex', alignItems: 'center', gap: 6, color: 'black', fontSize: 12, fontWeight: 400 }}>
					<span>
						Selecciona un campo:						
					</span>

				</div>
				<Segmented
					size='small'
					value={columnKey}
					options={[
						{ value: 'CATEGORY', label: 'Categorías' },
						{ value: 'CONTACT', label: 'Contacto' },
						{ value: 'HOURS', label: 'Horarios' },
						{ value: 'FESTIVES', label: 'Festivos' }
					]}
					onChange={(value: any) => {
						setExtraColumn(value);
						setColumns([...START_COLUMNS, EXTRA_COLUMNS[value], ...END_COLUMNS]);
					}}
				/>
			</div>
		);
	};

	const EXTRA_COLUMNS: any = {
		"CATEGORY": {
						title: getDynamicTitle('CATEGORY'),
						key: 'categories',						
						width: '350px',
						render: (text: string, record: any) => (<Categories categories={record.location.categories} />)
					},	
		"CONTACT": 	{
						title: getDynamicTitle('CONTACT'),
						key: 'contact',
						width: '350px',
						sorter: (a: any, b: any) => a.location.websiteUri.localeCompare(b.location.websiteUri),
						render: (text: string, record: any) => (<ContactGroup record={record.location} />)
					},
		"HOURS": 	{
						title: getDynamicTitle('HOURS'),
						key: 'hours',						
						width: '350px',
						render: (text: string, record: any) => (<Hours location={record.location} />)
					},
		"FESTIVES": 	
					{
						title: getDynamicTitle('FESTIVES'),
						key: 'specialHours',						
						width: '350px',
						render: (text: string, record: any) => (<Festives specialHours={record.location.specialHours} />)
					}
	};
	
	const [columns, setColumns] = useState([...START_COLUMNS, EXTRA_COLUMNS[extraColumn], ...END_COLUMNS]);

	const onSelectChange = (selectedRowKeys: any) => {
		setSelectedRowKeys(selectedRowKeys);
		setIndeterminate(true);
	}

	const onSelectAllCustom = (selected: boolean) => {
		setSelectedRowKeys(selected ? displayedLocations.map((row: any) => row.locationName) : []);
		setIndeterminate(false);
	}

	const rowSelection = {
		selectedRowKeys,
		onChange: onSelectChange,
		columnTitle: <Checkbox indeterminate={indeterminate} onChange={(e) => onSelectAllCustom(e.target.checked)}></Checkbox>,
		getCheckboxProps: (record: any) => ({
			disabled: !record.location.metadata?.hasVoiceOfMerchant,
			locationName: record.locationName,
		}),
	}

	const hasSelected = selectedRowKeys.length > 0;
	const massiveVisible = !hasSelected || !isUserAuthorized;
	
	/* Locales - Gestión masiva */

	return (
		<>
			<Card className='main-card-content'>
				
				<div style= {{width:'100%', display:'flex', justifyContent:'space-between'}}>
					<PageTitle
						title='Fichas de Negocio'
						pageInfo='Administra tus fichas de Google de manera masiva: completa toda la información disponible (portada, logo, teléfonos, etc.), optimiza tu estrategia de SEO local (impulsando tus keywords en las categorías, servicios, etc.), mantén horarios y días festivos actualizados, y supervisa posibles suspensiones o modificaciones externas no deseadas.'
						extra={
							<Button type='link' onClick={() => setLogsDrawer(true)}>
								Ver Registro
							</Button>
						}
					/>
				</div>
				<div className="card-container" style={{ marginTop: 14, padding: '6px 0 0' }}>
					{kpis && (
						<BlockInfoKpis
							kpis={kpis}
							openStatusFilter={openStatusFilter}
							onOpenStatusFilterChange={setOpenStatusFilter}
							compact
						/>
					)}
				</div>
				<div style={{ marginTop: 16, marginBottom: 0 }}>

					<Synchronized service={[SCHEDULEDJOB.GBP_LOCATIONS]}/>			

					<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12 }}>
						{/* Acciones Masivas visual container - compact */}
						<div 
							style={{
								background: massiveVisible ? '#f8fafc' : '#eef5ff',
								border: massiveVisible ? '1px dashed #b8c0cc' : '1px solid #4A90E2',
								borderRadius: '8px',
								padding: '5px 12px',
								display: 'flex',
								flexDirection: 'column',
								gap: 1,
								minWidth: 340,
								marginRight: 0,
								opacity: massiveVisible ? 0.85 : 1,
								transition: 'opacity 0.2s, border-color 0.2s, background 0.2s',
							}}
						>
							<div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
								<span style={{ 
									display: 'flex',
									alignItems: 'center',
									gap: 6,
									color: '#000',
									fontSize: 13,
									fontWeight: 700,
									whiteSpace: 'nowrap',
									letterSpacing: '0.02em',
								}}>
									<EditOutlined style={{ fontSize: 15, color: '#000' }} /> Acciones Masivas
								</span>
								<div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', minWidth: 0 }}>
									<Button
										type="link"
										onClick={() => setEditPanelVisible(true)}
										disabled={massiveVisible}
										style={{ display: 'flex', alignItems: 'center', minWidth: 54, justifyContent: 'center', padding: 0, fontSize: 13, height: 24 }}
									>
										{t('dictionary.edit')}
									</Button>
									<Button
										type="link"
										onClick={() => setPortadaPanel(true)}
										disabled={massiveVisible}
										style={{ display: 'flex', alignItems: 'center', minWidth: 54, justifyContent: 'center', padding: 0, fontSize: 13, height: 24 }}
									>
										{t('dictionary.cover')}
									</Button>
									<Button
										type="link"
										onClick={() => setLogoPanelVisible(true)}
										disabled={massiveVisible}
										style={{ display: 'flex', alignItems: 'center', minWidth: 54, justifyContent: 'center', padding: 0, fontSize: 13, height: 24 }}
									>
										{t('dictionary.logo')}
									</Button>
								</div>
							</div>
							{massiveVisible ? (
								<span style={{ fontSize: 12, color: '#4a6278', display: 'inline-flex', alignItems: 'center', gap: 4, whiteSpace: 'nowrap' }}>
									<CheckSquareOutlined />
									Selecciona locales en la tabla
								</span>
							) : (
								<span style={{
									alignSelf: 'flex-start',
									fontSize: 12,
									fontWeight: 600,
									color: '#334155',
									background: '#fff',
									border: '1px solid #93c5fd',
									borderRadius: 999,
									padding: '1px 8px',
									whiteSpace: 'nowrap',
								}}>
									{`${selectedRowKeys.length} de ${displayedLocations.length} seleccionados`}
								</span>
							)}
						</div>
						<PageFilters>
							<PageFilterField label='Región' active={filterLabel != null}>
								<SelectVirtualGroup onChange={(obj: any) => { setFilterLabel(obj);  }}/>
							</PageFilterField>
							<PageFilterField label='Estado' active={filterStatus !== true}>
								<Switch
									className='locations-status-switch'
									checked={filterStatus}
									onChange={setFilterStatus}
									checkedChildren="Operativas"
									unCheckedChildren="No Operativas"
								/>
							</PageFilterField>
						</PageFilters>
					</div>
				</div>	
				<TableLZM
					rowKey='locationName'
					scroll={{ x: true, y: 800 }}
					//scroll={{ y: 600 }}
					rowSelection={rowSelection}
					columns={columns}					
					pagination={{ defaultPageSize: 20 }}					
					//exportable={true}
					dataSource={displayedLocations}
					loading={isLoading}
				/>
				{editPanelVisible && (
					<GoogleEditPanel
						selectedRowKeys={selectedRowKeys}
						visible={editPanelVisible}
						onFinish={() => {
							setEditPanelVisible(false);
							setUpdateData(!updateData);
							setTimeout(() => {
								setLogsDrawer(true);
							}, 500);
						}}
						onCancel={() => {
							setEditPanelVisible(false);
						}}
					/>)
				}
				{logoPanelVisible && (
					<LogoMassivePanel
						selectedRowKeys={selectedRowKeys}
						visible={logoPanelVisible}
						onFinish={() => {
							setLogoPanelVisible(false);
							setUpdateData(!updateData);
							setTimeout(() => {
								setLogsDrawer(true);
							}, 500);
						}}
						onCancel={() => {
							setLogoPanelVisible(false);
						}}
					/>)
				}
				{portadaPanel && (
					<PortadaMassivePanel
						selectedRowKeys={selectedRowKeys}
						visible={portadaPanel}
						onFinish={() => {
							setPortadaPanel(false);
							setUpdateData(!updateData);
							setTimeout(() => {
								setLogsDrawer(true);
							}, 500);
						}}
						onCancel={() => {
							setPortadaPanel(false);
						}}
					/>)
				}												
			</Card>			
			{googleUpdatedModal && (
					<GoogleUpdateModal
						location={googleUpdatedModal}
						onRefreshed={(status) => {
							setLocationsData((prev: any[]) =>
								prev.map((row: any) =>
									row.locationName === googleUpdatedModal.locationName
										? { ...row, googleStatus: status }
										: row
								)
							);
							setGoogleUpdatedModal((current: any) =>
								current ? { ...current, googleStatus: status } : current
							);
						}}
						onFinish={() => {
							setGoogleUpdatedModal(null);
						}}
						onCancel={() => {
							setGoogleUpdatedModal(null);
						}}
					/>)
				}			
		</>
	)
}